// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-checkbox {
  margin-right: 0;
}

.notification-checkbox {
  max-width: 30px;
}

.ios-checkbox ion-checkbox::part(container) {
  border-radius: 6px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/information-and-security/manage-notifications/manage-notifications.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AACA;EACI,eAAA;AAEJ;;AAAA;EACI,kBAAA;AAGJ","sourcesContent":["ion-checkbox{\r\n    margin-right: 0;\r\n}\r\n.notification-checkbox {\r\n    max-width: 30px;\r\n}\r\n.ios-checkbox ion-checkbox::part(container) {\r\n    border-radius: 6px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
